import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { StyledButton, StyledContent, StyledSpinner } from './Button.styles';
const Button = React.forwardRef(({ children, variant, size, icon, iconPosition, fullWidth, disabled, loading, loadingAriaLabel, href, ...props }, ref) => (_jsxs(StyledButton, { ref: ref, variant: variant, size: size, iconPosition: iconPosition, fullWidth: fullWidth, loading: loading, disabled: disabled || loading, href: !disabled ? href : undefined, ...props, children: [_jsxs(StyledContent, { css: { opacity: loading ? 0 : 1 }, "aria-hidden": loading, children: [icon, children] }), loading && (_jsx(StyledSpinner, { "aria-busy": 'true', "aria-live": 'polite', "aria-label": loadingAriaLabel }))] })));
Button.displayName = 'Button';
Button.defaultProps = {
    variant: 'primary',
    size: 'sm',
    iconPosition: 'left',
    loadingAriaLabel: 'Loading',
};
export default Button;
